import { Component, OnInit, Input } from '@angular/core';
import { CriterionItem } from '../criterion-item'
import { CriterionService } from '../criterion.service'

@Component({
  selector: 'app-criterion-item-box',
  templateUrl: './criterion-item-box.component.html',
  styleUrls: ['./criterion-item-box.component.css']
})
export class CriterionItemBoxComponent implements OnInit {
  @Input() criterionItem: CriterionItem

  constructor(
    private cs: CriterionService
  ) { }

  set regexp(txt) {
    this.cs.setCIregexp(this.criterionItem, txt)
  }

  get regexp() {
    return this.cs.getCIregexp(this.criterionItem)
  }

  set weight(txt) {
    this.cs.setCIweight(this.criterionItem, txt)
  }

  get weight() {
    return this.cs.getCIweight(this.criterionItem)
  }
  ngOnInit() {
    this.cs.initCIvalues(this.criterionItem,
      this.criterionItem.regexp,
      this.criterionItem.weight
    )
  }

}



// WEBPACK FOOTER //
// ./src/app/criterion-item-box/criterion-item-box.component.ts